export const VERIFY_THE1 = "VERIFY_THE1"
export const VERIFY_THE1_ERROR = "VERIFY_THE1_ERROR"
export const REGISTER_TRANSFER = "REGISTER_TRANSFER"
export const REGISTER_TRANSFER_ERROR = "REGISTER_TRANSFER_ERROR"